import { GraphQLResult, graphqlOperation } from "@aws-amplify/api-graphql";
import { generateClient } from "aws-amplify/api";
import { InfoNameEnum } from "common/enums/InfoNameEnum";
import {
  AgreeCognitoUserFMutation,
  AgreeCognitoUserFMutationVariables,
  DefaultCondition,
  GetUserQuery,
  ListUsersBySearchInfoQuery,
  ListUsersBySearchInfoQueryVariables,
  SaveDefaultConditionOfUserFMutation,
  SaveDefaultConditionOfUserFMutationVariables,
  User
} from "graphql/API";
import {
  agreeCognitoUserF as agreeCognitoUserFMutation,
  saveDefaultConditionOfUserF as saveDefaultConditionOfUserFMutation
} from "graphql/mutations";
import {
  getUser as getUserQuery,
  listUsersBySearchInfo as listUsersBySearchInfoQuery
} from "graphql/queries";
import { getSumoraAuthToken } from "../credentials";

export const getUser = async (
  username: string | undefined
): Promise<GetUserQuery | undefined> => {
  if (username) {
    const client = generateClient();
    const userData = (await client.graphql({
      ...graphqlOperation(getUserQuery, {
        username: username,
        infoName: InfoNameEnum.master
      }),
      authMode: "lambda",
      authToken: await getSumoraAuthToken()
    })) as GraphQLResult<GetUserQuery>;

    return userData.data;
  }
};

export const listUsersByCompanyRecNo = async (
  companyRecNo: string
): Promise<User[]> => {
  const client = generateClient();
  const variables: ListUsersBySearchInfoQueryVariables = {
    infoName: InfoNameEnum.companyId,
    searchInfo: { beginsWith: `${companyRecNo}-` }
  };

  const users: Map<string, User> = new Map();

  while (true) {
    const res = (await client.graphql({
      ...graphqlOperation(listUsersBySearchInfoQuery, variables),
      authMode: "lambda",
      authToken: await getSumoraAuthToken()
    })) as GraphQLResult<ListUsersBySearchInfoQuery>;

    if (res.data?.listUsersBySearchInfo?.items) {
      res.data.listUsersBySearchInfo.items.forEach((item) => {
        if (item) {
          users.set(item.username, {
            ...item,
            __typename: "User"
          });
        }
      });
    }

    if (res.data?.listUsersBySearchInfo?.nextToken) {
      variables.nextToken = res.data?.listUsersBySearchInfo?.nextToken;
    } else {
      break;
    }
  }

  return Array.from(users.values());
};

export const agreeCognitoUser = async (
  username: string,
  agreement: boolean
) => {
  const variables: AgreeCognitoUserFMutationVariables = {
    username: username || "",
    agreement: agreement || false
  };

  const client = generateClient();
  const res = (await client.graphql({
    ...graphqlOperation(agreeCognitoUserFMutation, variables),
    authMode: "lambda",
    authToken: await getSumoraAuthToken()
  })) as GraphQLResult<AgreeCognitoUserFMutation>;

  if (res.data?.agreeCognitoUserF?.errorMessage) {
    throw res.data?.agreeCognitoUserF.errorMessage;
  }

  if (
    res?.data?.agreeCognitoUserF?.errorMessage &&
    res?.data?.agreeCognitoUserF?.errorMessage !== ""
  ) {
    throw res.data?.agreeCognitoUserF?.errorMessage;
  }

  return res.data?.agreeCognitoUserF;
};

export const saveDefaultConditionOfUser = async (
  username: string,
  defaultCondition: Partial<DefaultCondition>
) => {
  delete defaultCondition.__typename;

  window.console.log("defaultCondition:", defaultCondition);

  const variables: SaveDefaultConditionOfUserFMutationVariables = {
    username: username || "",
    defaultCondition: defaultCondition || {}
  };

  const client = generateClient();
  const res = (await client.graphql({
    ...graphqlOperation(saveDefaultConditionOfUserFMutation, variables),
    authMode: "lambda",
    authToken: await getSumoraAuthToken()
  })) as GraphQLResult<SaveDefaultConditionOfUserFMutation>;

  if (res.data?.saveDefaultConditionOfUserF?.errorMessage) {
    throw res.data?.saveDefaultConditionOfUserF.errorMessage;
  }

  if (
    res?.data?.saveDefaultConditionOfUserF?.errorMessage &&
    res?.data?.saveDefaultConditionOfUserF?.errorMessage !== ""
  ) {
    throw res.data?.saveDefaultConditionOfUserF?.errorMessage;
  }

  return res.data?.saveDefaultConditionOfUserF;
};
